
export class CommonKey {
    public static readonly ROOM_ID = "roomId";
}